import React from 'react';

const CloseIcon = ({ width = 20, height = 20, ...rest }) => {
  // tslint:disable max-line-length
  return (
    <svg width={width} height={height} {...rest} viewBox="0 0 12 12">
      <g>
        <path d="M0.22823094,0.22823094 C0.53253886,-0.07607698 1.02591948,-0.07607698 1.3302274,0.22823094 L1.3302274,0.22823094 L6,4.898 L10.6697726,0.22823094 C10.9740805,-0.07607698 11.4674611,-0.07607698 11.7717691,0.22823094 C12.0484126,0.504874504 12.073562,0.937776498 11.8472173,1.24283069 L11.7717691,1.3302274 L7.102,6 L11.7717691,10.6697726 L11.8472173,10.7571693 C12.073562,11.0622235 12.0484126,11.4951255 11.7717691,11.7717691 C11.4674611,12.076077 10.9740805,12.076077 10.6697726,11.7717691 L10.6697726,11.7717691 L6,7.102 L1.3302274,11.7717691 C1.02591948,12.076077 0.53253886,12.076077 0.22823094,11.7717691 C-0.0484126236,11.4951255 -0.0735620385,11.0622235 0.152782695,10.7571693 L0.22823094,10.6697726 L4.898,6 L0.22823094,1.3302274 L0.152782695,1.24283069 C-0.0735620385,0.937776498 -0.0484126236,0.504874504 0.22823094,0.22823094 Z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
};

export default CloseIcon;
